// Author Liang Gang Qiang
// Date 2021-10-15 09:54:24

class ImfMstShift {
constructor({
        id = null,
        shiftCode = '',
        name = '',
        remark = ''}
= {}) {
    this.id = id;
    this.shiftCode = shiftCode;
    this.name = name;
    this.remark = remark;
}
}

function newEntity() {
return new ImfMstShift();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.imfMstShift.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftCode',
        label: 'label.em.admin.imfMstShift.grid.shiftCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.admin.imfMstShift.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstShift.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    shiftCodeFilter : "",
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'shiftCodeFilter',
        label: 'label.em.admin.imfMstShift.filter.shiftCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.admin.imfMstShift.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'shiftCode',
        label: 'label.em.admin.imfMstShift.entity.shiftCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'name',
        label: 'label.em.admin.imfMstShift.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstShift.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {ImfMstShift, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
